import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './PDFNewsletterPopup.css';

const RoboticsCampPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hasSeenPopup = localStorage.getItem('stemtrixCampPosterSeen');
    if (!hasSeenPopup) {
      const timer = setTimeout(() => {
        setShow(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem('stemtrixCampPosterSeen', 'true');
  };

  const downloadImage = () => {
    const link = document.createElement('a');
    link.href = '/newsletters/poster.jpg'; // adjust path as needed
    link.download = 'Stemtrix_Robotics_Camp_Poster.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      className="pdf-newsletter-modal"
    >
      <div className="pdf-newsletter-popup">
        <button className="popup-close" onClick={handleClose}>×</button>

        <div className="popup-header">
          <div className="popup-badge">Upcoming Event</div>
          <h2>Back to Basics Robotics Challenge</h2>
          <p>Back to Basics Challenge – Brookhouse School, Runda</p>
        </div>

        <div className="popup-image-wrapper">
          <img
            src="/newsletters/poster.jpeg"  // Make sure this path is correct
            alt="Robotics challenge Poster"
            className="popup-poster-image"
          />
        </div>

        <div className="popup-footer">
          <Button variant="primary" className="download-btn" onClick={downloadImage}>
            Download Poster
          </Button>
          <Button variant="outline-secondary" onClick={handleClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default RoboticsCampPopup;
